module.exports = __webpack_public_path__ + "static/WEDDING E&M-547-2204e714d1df7a878fed2f8cf980ef6b.jpg";